import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StockAmazonRecapPage } from './stock-amazon-recap.page';

const routes: Routes = [
  {
    path: '',
    component: StockAmazonRecapPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StockAmazonRecapPageRoutingModule {}
